import React from 'react';
import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

export interface MobileProgressBarProps {
  currentStepIndex: number;
  totalSteps: number;
  progressPercentage: number;
  currentStepLabel: string;
  className?: string;
}

export const MobileProgressBar: React.FC<MobileProgressBarProps> = ({
  currentStepIndex,
  totalSteps,
  progressPercentage,
  currentStepLabel,
  className,
}) => {
  const { t } = useTranslation('onboarding');

  return (
    <div className={cn('flex flex-col w-full max-w-xs', className)}>
      <div className="flex justify-between items-center mb-1 text-[10px] uppercase tracking-wider font-bold text-muted-foreground">
        <span>{currentStepLabel}</span>
        <span>
          {t('wizard.status.count_of_total', {
            current: currentStepIndex,
            total: totalSteps,
          })}
        </span>
      </div>
      <Progress value={progressPercentage} className="h-1.5" />
    </div>
  );
};
